// The one object a next-path splat character's placement lives on.
// Notes: ~/comments/aos-threejs-poc/AvatarRoot_group_not_the_spark_renderer.md

import { useEffect, useMemo } from 'react'
import * as THREE from 'three'
import { useThree } from '@react-three/fiber'
import { publishDebug, retractDebug } from '../../ogs/pipeline/ogsDebug.ts'

/** A stable group for the transform gizmo, parented under the scene. Renders nothing itself. */
export function useAvatarRoot() {
  const scene = useThree((state) => state.scene)
  const root = useMemo(() => {
    const group = new THREE.Group()
    group.name = 'ogs-next-avatar-root'
    return group
  }, [])

  useEffect(() => {
    scene.add(root)
    publishDebug('__OGS_AVATAR_ROOT_NEXT__', root)
    return () => {
      scene.remove(root)
      retractDebug('__OGS_AVATAR_ROOT_NEXT__')
    }
  }, [scene, root])

  return root
}
